export default __webpack_public_path__ + "static/media/FRAX.bf20f167.png";